import React, { useState, useRef } from "react"
import { Formik, Field, Form, ErrorMessage } from "formik"
import * as Yup from "yup"
import axios from "axios"
import { navigate } from "gatsby"

import { SavorReasonLists } from "./savorReasonLists"
import Logo from "../BrandLogo"

import { useContent } from "../../context/contentProvider"

import "./index.css"

const ContactForm = ({ pageName="", contactForm, colorValue, languageVal='English', pageData }) => {
    const [isLoading, setIsLoading] = useState(false);

    console.log(languageVal)

    const isWhite = colorValue === 'rgb(229, 62, 62)' ? 'text-white': 'text--dark'

    return (
        <div className="block" style={{ backgroundColor: colorValue }}>
            <div className="component-form">
                <h3 className={`mt-0 pt-16 mb-10 uppercase text-center ${isWhite}`}>
                    <img src={'https://images.ctfassets.net/vhts96p7twn6/6zs5NNwwZdvltZCMbeB6Zi/6267679e0c853b966b36b9f40958db99/SB_Star_burst-02.png'} className="mb-0 w-h-32 vertical-text-top mr-5" alt="Savor Brands" />
                    {languageVal === 'Spanish' 
                        ? '¡Contacta con nuestro equipo!' : languageVal === 'French'
                            ? 'Contactez notre équipe !' : languageVal === 'Portuguese'
                                ? 'Entre em contato com nossa equipe!' : languageVal === 'Arabic'
                                    ? 'اتصل بفريقنا!' : languageVal === 'German'
                                        ? 'Kontaktieren Sie unser Team!' : languageVal === 'Italian'
                                            ? 'Contatta il nostro team!' : languageVal === 'Japanese'
                                                ? '私たちのチームにご連絡ください!' : languageVal === 'Indian - Hindi'
                                                    ? 'हमारी टीम से संपर्क करें!' : 'Contact Our Team!'}
                </h3>
                <div className="grid col-4-8 col-1-md form-wrap">
                    <div className="left-wrap">
                        <div className="left-wrap--content">
                            <Logo href="/" title="Savor Brands Logo" isDarkMode={false} className="mr-0" />
                            <p className="mt-10 mb-0 text-white">
                                {languageVal === 'Spanish' 
                                    ? '¡No dudes en contactar con nuestro equipo!' : languageVal === 'French'
                                        ? `N'hésitez pas à contacter notre équipe !` : languageVal === 'Portuguese'
                                            ? 'Entre em contato com nossa equipe!' : languageVal === 'Arabic'
                                                ? 'لا تتردد في التواصل مع فريقنا!' : languageVal === 'German'
                                                    ? 'Bitte wenden Sie sich an unser Team!' : languageVal === 'Italian'
                                                        ? 'Non esitate a contattare il nostro team!' : languageVal === 'Japanese'
                                                            ? 'ぜひお気軽に弊社のチームまでご連絡ください。' : languageVal === 'Indian - Hindi'
                                                                ? 'कृपया हमारी टीम से संपर्क करने में संकोच न करें!' : 'Please feel free to reach out our Team!'}
                            </p>
                            <a href="tel:8085998988" className="mt-10 text-white decoration-none link--number">(808)599-8988</a>
                        </div>
                        <SavorReasonLists listTitle={contactForm && contactForm.listTitle ? contactForm.listTitle:null} languageVal={languageVal} />
                    </div>
                    <div className="right-wrap">
                        <Formik
                        initialValues={{ name: '', company: '', email: '', phone: '', message: '', location: '' }}
                        validationSchema={Yup.object({
                            name: Yup.string().required('Required'),
                            company: Yup.string().required('Required'),
                            email: Yup.string().email('Invalid email address').required('Required'),
                            phone: Yup.string().required("Required"),
                            message: Yup.string().required('Required'),
                            location: Yup.string().required('Required')
                        })}
                        onSubmit={async (values, { resetForm, setSubmitting }) => {
                            try {
                                setIsLoading(true);
                                const requestData = {
                                    name: values.name,
                                    company: values.company,
                                    phone: values.phone,
                                    message: values.message,
                                    email: values.email,
                                    location: values.location,
                                    landingPageName: pageName
                                }
                                await axios.post("https://g5wf04qzb1.execute-api.us-west-2.amazonaws.com/production/sendemail", requestData);
                                navigate('/thank-you/');
                                resetForm();
                                setIsLoading(false);
                            } catch (error) {
                                alert("Form submission failed. Please try again.");
                            }
                        }}
                        >
                            {({setFieldValue, values}) => (
                                <Form>
                                    <div className="grid col-2 col-1-md gap-10">
                                        <div className="form-field">
                                            <Field name="name" type="text" placeholder={languageVal === 'Spanish' 
                                                ? 'Nombre' : languageVal === 'French'
                                                    ? `Nom` : languageVal === 'Portuguese'
                                                        ? 'Nome' : languageVal === 'Arabic'
                                                            ? 'اسم' : languageVal === 'German'
                                                                ? 'Name' : languageVal === 'Italian'
                                                                    ? 'Nome' : languageVal === 'Japanese'
                                                                        ? '名前' : languageVal === 'Indian - Hindi'
                                                                            ? 'नाम' : 'Name'} />
                                            <ErrorMessage className="form-field--err" name="name" component="div" />
                                        </div>
                                        <div className="form-field">
                                            <Field type="tel" id="phone" name="phone" placeholder={languageVal === 'Spanish' 
                                                ? 'Teléfono' : languageVal === 'French'
                                                    ? `Téléphone` : languageVal === 'Portuguese'
                                                        ? 'Telefone' : languageVal === 'Arabic'
                                                            ? 'هاتف' : languageVal === 'German'
                                                                ? 'Telefon' : languageVal === 'Italian'
                                                                    ? 'Telefono' : languageVal === 'Japanese'
                                                                        ? '電話' : languageVal === 'Indian - Hindi'
                                                                            ? 'फ़ोन' : 'Phone'} />
                                            <ErrorMessage className="form-field--err" name="phone" component="div" />
                                        </div>
                                    </div>
                                    <div className="grid col-2 col-1-md gap-10">
                                        <div className="form-field">
                                            <Field name="email" type="email" placeholder={languageVal === 'Spanish' 
                                                ? 'Correo electrónico' : languageVal === 'French'
                                                    ? `E-mail` : languageVal === 'Portuguese'
                                                        ? 'E-mail' : languageVal === 'Arabic'
                                                            ? 'بريد إلكتروني' : languageVal === 'German'
                                                                ? 'E-Mail' : languageVal === 'Italian'
                                                                    ? 'E-mail' : languageVal === 'Japanese'
                                                                        ? '電子メール' : languageVal === 'Indian - Hindi'
                                                                            ? 'ईमेल' : 'Email'}  />
                                            <ErrorMessage className="form-field--err" name="email" component="div" />
                                        </div>
                                        <div className="form-field">
                                            <Field name="company" type="text" placeholder={languageVal === 'Spanish' 
                                                ? 'Compañía' : languageVal === 'French'
                                                    ? `Entreprise` : languageVal === 'Portuguese'
                                                        ? 'Empresa' : languageVal === 'Arabic'
                                                            ? 'شركة' : languageVal === 'German'
                                                                ? 'Unternehmen' : languageVal === 'Italian'
                                                                    ? 'Azienda' : languageVal === 'Japanese'
                                                                        ? '会社' : languageVal === 'Indian - Hindi'
                                                                            ? 'कंपनी' : 'Company'} />
                                            <ErrorMessage className="form-field--err" name="company" component="div" />
                                        </div>
                                    </div>
                                    <div className="form-field">
                                        <Field name="location" type="text" placeholder={languageVal === 'Spanish' 
                                                ? 'Ubicación' : languageVal === 'French'
                                                    ? `Emplacement` : languageVal === 'Portuguese'
                                                        ? 'Localização' : languageVal === 'Arabic'
                                                            ? 'موقع' : languageVal === 'German'
                                                                ? 'Standort' : languageVal === 'Italian'
                                                                    ? 'Posizione' : languageVal === 'Japanese'
                                                                        ? '位置' : languageVal === 'Indian - Hindi'
                                                                            ? 'जगह' : 'Location'} />
                                        <ErrorMessage className="form-field--err" name="location" component="div" />
                                    </div>
                                    <div className="form-field">
                                        <Field name="message" as="textarea" placeholder={languageVal === 'Spanish' 
                                                ? '¿En qué estás interesado?' : languageVal === 'French'
                                                    ? `Qu'est-ce qui vous intéresse ?` : languageVal === 'Portuguese'
                                                        ? 'No que você está interessado?' : languageVal === 'Arabic'
                                                            ? 'ما الذي يثير اهتمامك؟' : languageVal === 'German'
                                                                ? 'Was interessiert Sie?' : languageVal === 'Italian'
                                                                    ? 'Cosa ti interessa?' : languageVal === 'Japanese'
                                                                        ? '何に興味がありますか?' : languageVal === 'Indian - Hindi'
                                                                            ? 'आप किस चीज़ में रुचि रखते हैं?' : 'What are you interested in?'} />
                                        <ErrorMessage className="form-field--err" name="message" component="div" />
                                    </div>
                                    <div className="flex justify-center action">
                                        <button type="submit" className={`btn-brand-color-linear bold${isLoading ? ' btn--disabled':''}`}>
                                            {languageVal === 'Spanish' 
                                                    ? 'Entregar' : languageVal === 'French'
                                                        ? `Soumettre` : languageVal === 'Portuguese'
                                                            ? 'Enviar' : languageVal === 'Arabic'
                                                                ? 'يُقدِّم' : languageVal === 'German'
                                                                    ? 'Einreichen' : languageVal === 'Italian'
                                                                        ? 'Invia' : languageVal === 'Japanese'
                                                                            ? '提出する' : languageVal === 'Indian - Hindi'
                                                                                ? 'जमा करना' : 'Submit'}
                                        </button>
                                    </div>
                                    {/* <Popup/> */}
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactForm